import { useEffect } from 'react'
import { useAuth } from '@/contexts/AuthContext'
import { useClientContext } from '@/contexts/ClientContext'

/**
 * Aplica branding sutil quando o user logado é client_user. Substitui apenas
 * --color-accent (cor de accent secundária) por uma cor do cliente, preservando
 * o tema dark padrão do Runnaflow. Logo do cliente é renderizado em
 * componentes específicos (Sidebar header) que leem do profile.client.client_ref.
 *
 * Decisão #2 da reunião: branding sutil (logo + accent), não tema completo —
 * evita risco de cor mal escolhida quebrar contraste no dark mode.
 */
export default function ClientBrandingApplier() {
  const { profile } = useAuth()
  const { activeClient } = useClientContext()

  // Para client_user: usa o cliente do profile (lock).
  // Para team_member: aplica branding do cliente ATIVO no shell, se houver.
  const isClientUser = profile?.user.user_type === 'client_user'
  const branding = isClientUser
    ? profile?.client?.client_ref?.branding
    : activeClient?.branding

  useEffect(() => {
    const root = document.documentElement
    const prevAccent = root.style.getPropertyValue('--color-accent')

    if (branding?.accent_color) {
      // Aplica como accent secundário. Não substitui --color-primary (purple
      // base do Runnaflow) pra evitar quebrar contraste de elementos críticos.
      root.style.setProperty('--color-accent', branding.accent_color)
      root.style.setProperty('--color-client-accent', branding.accent_color)
    } else {
      root.style.removeProperty('--color-client-accent')
    }

    return () => {
      // Restaura ao desmontar (logout/troca de cliente)
      if (prevAccent) {
        root.style.setProperty('--color-accent', prevAccent)
      } else {
        root.style.removeProperty('--color-accent')
      }
      root.style.removeProperty('--color-client-accent')
    }
  }, [branding?.accent_color])

  return null
}
